var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-content"},[_c('div',{staticClass:"barometer row"},[_c('div',{staticClass:"barometer-copy col-xs-16 col-xs-offset-1 col-sm-14 col-sm-offset-2 col-md-5 col-md-offset-2"},[_vm._t("copy")],2),_vm._v(" "),_c('div',{staticClass:"barometer-indicators col-xs-16 col-xs-offset-1 col-sm-14 col-sm-offset-2 col-md-8 col-md-offset-1"},[_c('div',{staticClass:"row mr-hack"},[_vm._t("default")],2)])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-612f3a98","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Barometer.vue
// module id = null
// module chunks = 